import { render, staticRenderFns } from "./import-being-processed.vue?vue&type=template&id=21ce04b4"
import script from "./import-being-processed.vue?vue&type=script&lang=js"
export * from "./import-being-processed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports